import '../app';
import axios from 'axios';
const center = { lat: 45.570515, lng: -73.422232 }; // 1421 rue Ampère.
const address = document.getElementById('address');
const stores = document.getElementById('stores');
let map;
let infoWindow;
let geocoder;
let markers = [];
/**
 * Initier la Google Map.
 *
 * Fontion appelé par le script de Google lorsqu'il est chargé.
 *
 * @return {void}
 */
window.initMap = () => {
    map = new google.maps.Map(document.getElementById("map"), {
        center,
        zoom: 10
    });
    infoWindow = new google.maps.InfoWindow;
    geocoder = new google.maps.Geocoder;
    setAddressFromBrowser();
    initListeners();
};
/**
 * Peupler le champ "address" en fonction de la position retournée par le navigateur.
 *
 * @return {void}
 */
function setAddressFromBrowser() {
    if (!navigator.geolocation) {
        setInfoWindow('Error: Your browser doesn\'t support geolocation.', map.getCenter());
    }
    navigator.geolocation.getCurrentPosition((position) => {
        const request = {
            location: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            }
        };
        geocoder.geocode(request, (results, status) => {
            if (status != 'OK') {
                setInfoWindow(`Geocoder failed due to: ${status}.`, map.getCenter());
                return;
            }
            if (!results) {
                setInfoWindow('No results found.', map.getCenter());
                return;
            }
            const formattedAddress = results[0].formatted_address;
            address.value = formattedAddress;
            map.setCenter(request.location);
            deleteMarkers();
            addMarker(request.location, formattedAddress);
        });
    }, () => {
        setInfoWindow('Error: The geolocation service failed.', map.getCenter());
    });
}
/**
 * Fixer le contenu ainsi que la position de l'InfoWindow.
 *
 * @param {string} content
 * @param {(google.maps.LatLng | google.maps.LatLngLiteral | null | undefined)} position
 * @return {void}
 */
function setInfoWindow(content, position) {
    infoWindow.close();
    infoWindow.setContent(content);
    infoWindow.setPosition(position);
    infoWindow.open(map);
}
/**
 * Supprimer tous les marqueurs de la Google Map.
 *
 * @return {void}
 */
function deleteMarkers() {
    markers.forEach((marker) => {
        marker.setMap(null);
    });
    markers = [];
}
/**
 * Ajouter un marqueur sur la Google Map.
 *
 * @param {google.maps.LatLngLiteral} latLngLiteral
 * @param {string} [title]
 * @param {(string|google.maps.MarkerLabel)} [label]
 * @return {*}  {google.maps.Marker}
 */
function addMarker(latLngLiteral, title, label) {
    const marker = new google.maps.Marker({ position: latLngLiteral, map: map });
    title && marker.setTitle(title);
    label && marker.setLabel(label);
    markers.push(marker);
    return marker;
}
/**
 * Initier les écouteurs sur:
 *
 *   - Les boutons KM & MI;
 *   - Le bouton "Locate";
 *   - La section "stores".
 *
 * @return {void}
 */
function initListeners() {
    const km = document.getElementById('units-km');
    const mi = document.getElementById('units-mi');
    [km, mi].forEach((unit) => {
        unit.addEventListener('click', () => {
            ajusterRadius(unit);
        });
    });
    const findAStore = document.getElementById('find-a-store');
    findAStore.addEventListener('submit', (ev) => {
        ev.preventDefault();
        setLatLngFromAddress(address.value, findAStore);
    });
    stores.addEventListener('click', (ev) => {
        const evTarget = ev.target;
        const closest = evTarget.closest('.stores__store__header');
        if (!closest) {
            return;
        }
        const li = closest.parentElement.parentElement;
        li.classList.toggle('stores__list__item--active');
    });
}
/**
 * Ajuster le texte KM / MI du champ «radius» en fonction des champs «units-km» | «units-mi».
 *
 * @param {HTMLInputElement} radio Champ «units-km» | «units-mi».
 * @return {void}
 */
function ajusterRadius(radio) {
    const radius10 = document.getElementById('radius-10');
    const radius25 = document.getElementById('radius-25');
    const radius50 = document.getElementById('radius-50');
    [radius10, radius25, radius50].forEach((radius) => {
        let innerHtml = radius.parentElement.innerHTML;
        innerHtml = innerHtml.replace(/KM|MI/, radio.value);
        radius.parentElement.innerHTML = innerHtml;
    });
}
/**
 * Obtenir une latitude et une longitude en fonction du champ «address».
 *
 * - Placer un marqeur sur la Google Map à l'adresse «address».
 * - Centrer la Google Map à l'adresse «address».
 * - Peupler les champs longitude et latitude (hidden) du formulaire.
 * - Appeler la fonction listStores. // ? Pas idéal 🤷‍♂️.
 *
 * @param {string} address Valeur du champ «address».
 * @param {HTMLFormElement} findAStore Formulaire #find-a-store.
 * @return {void}
 */
function setLatLngFromAddress(address, findAStore) {
    geocoder.geocode({ address: address }, function (results, status) {
        if (status != 'OK') {
            setInfoWindow(`Geocoder failed due to: ${status}.`, map.getCenter());
            return;
        }
        if (!results) {
            setInfoWindow('No results found.', map.getCenter());
            return;
        }
        const latLng = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
        const formattedAddress = results[0].formatted_address;
        deleteMarkers();
        addMarker(latLng, formattedAddress);
        map.setCenter(latLng);
        document.getElementById('latitude').value = String(latLng.lat);
        document.getElementById('longitude').value = String(latLng.lng);
        listStores(findAStore);
    });
}
/**
 * Mettre à jour le DOM de #stores en fonction des champs du formulaire #find-a-store.
 *
 * @param {HTMLFormElement} findAStore
 * @return {void}
 */
function listStores(findAStore) {
    const formData = new FormData(findAStore);
    let html = '';
    axios
        .get('/en/stores.json', {
        params: {
            units: formData.get('units'),
            radius: formData.get('radius'),
            latitude: formData.get('latitude'),
            longitude: formData.get('longitude')
        }
    })
        .then((response) => {
        Array.from(response.data).forEach((store, index) => {
            const marker = addMarker({
                lat: parseFloat(store.latitude),
                lng: parseFloat(store.longitude)
            }, store.name, String(index + 1));
            marker.store = dataToHtmlInfoWindow(store);
            marker.addListener('click', () => {
                setInfoWindow(marker.store, marker.getPosition());
            });
            // HTML de la liste de magasins
            html += dataToHtml(index, store);
        });
    })
        .then(() => {
        const productAvailability = document.getElementById('product-availability');
        const stores = document.getElementById('stores');
        const days = JSON.parse(stores.dataset.days); // Traductions.
        const missingStore = JSON.parse(stores.dataset.missingStore); // Traductions.
        if (html) {
            productAvailability.classList.add('stores__product-availability--active');
            html = `
                    <ol class="stores__list">
                        ${html}
                    </ol>
                `;
            for (const [day, translation] of Object.entries(days)) {
                html = html.replaceAll(day, translation);
            }
        }
        else {
            productAvailability.classList.remove('stores__product-availability--active');
        }
        html += `
                <div class="stores__add-your-store-container">
                    <a class="stores__add-your-store link" href="/${stores.dataset.locale}/pages/embedded-forms?name=missing-store">
                        <span>${missingStore[0]}</span> ${missingStore[1]}
                    </a>
                </div>
            `;
        stores.innerHTML = html;
    });
}
/**
 * Retourner l'HTML de l'infoWindow d'un magasin (un Google Map marker).
 *
 * @param {Store} store Interface Store (principalement les champs de la table `spectra`.`stores`).
 * @return {string}
 */
function dataToHtmlInfoWindow(store) {
    return `
        <article class="stores__info-window">
            <div class="stores__info-window__header">
                <h4 class="stores__info-window__title">${store.name}</h4>
                <span>${parseFloat(store.distance).toFixed(2)} ${document.querySelector('input[name=units]:checked').value}</span>
            </div>
            <address class="stores__info-window__address">
                <div>
                    ${store.address1}<br>
                    ${store.city}, ${store.state}, ${store.country}<br>
                    ${store.zip}
                </div>
                <div>
                    ${store.tel1 ? `<a href="tel:${store.tel1}">${store.tel1}</a>` : ''}
                    ${store.website ? `<a href="${store.website}" target="_blank" rel="noopener">${store.website}</a>` : ''}
                </div>
            </address>
        </article>
    `;
}
/**
 * Retourner l'HTML d'un article représentant un magasin.
 *
 * La section #stores est composée de tous les magasins qui correspondent à la recherhce.
 *
 * @param {number} index L'index de la boucle forEach qui appelle la fonction.
 * @param {Store} store Interface Store (principalement les champs de la table `spectra`.`stores`).
 * @return {string}
 */
function dataToHtml(index, store) {
    const heuresOuverture = () => {
        let tableContents = ``;
        ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'].forEach((day) => {
            const ouverture = store[`${day}_ouverture`];
            const fermeture = store[`${day}_fermeture`];
            if (ouverture || fermeture) {
                tableContents += `
                    <tr>
                        <td>${day}</td>
                        <td>
                            ${ouverture ? ouverture.slice(0, 5) : 'N/A'}
                            -
                            ${fermeture ? fermeture.slice(0, 5) : 'N/A'}
                        </td>
                    </tr>
                `;
            }
            else {
                tableContents += `
                    <tr>
                        <td>${day}</td>
                        <td>N/A</td>
                    </tr>
                `;
            }
        });
        if ((tableContents.match(/<td>N\/A<\/td>/g) || []).length == 7) { // Aucune information.
            return '';
        }
        tableContents.replaceAll('<td>N/A - N/A</td>', 'closed');
        const tableContainer = `
            <div class="stores__store__table-container">
                <table class="stores__store__opening-hours">
                    <caption>Opening Hours</caption>
                    <tbody>
                        ${tableContents}
                    </tbody>
                </table>
            </div>
        `;
        return tableContainer;
    };
    return `
        <li class="stores__list__item${index == 0 ? ' stores__list__item--active' : ''}">
            <article class="stores__store">
                <div class="stores__store__header">
                    <div class="stores__store__title">
                        <span>${index + 1}.</span>
                        <h4>${store.name}</h4>
                    </div>
                    <span class="stores__store__distance">${parseFloat(store.distance).toFixed(2)} ${document.querySelector('input[name=units]:checked').value}</span>
                </div>
                <div class="stores__store__details">
                    <address class="stores__store__address">
                        <div>
                            ${store.address1}<br>
                            ${store.city}, ${store.state}, ${store.country}<br>
                            ${store.zip}
                        </div>
                        <div>
                            ${store.tel1 ? `<a href="tel:${store.tel1}">${store.tel1}</a><br>` : ''}
                            ${store.website ? `<a href="${store.website}" target="_blank" rel="noopener">${store.website}</a>` : ''}
                        </div>
                    </address>
                    ${heuresOuverture()}
                </div>
            </article>
        </li>
    `;
}
/**
 * Dynamiquement télécharger le script de Google Maps et l'ajouter à la fin du corps de la page.
 */
(() => {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAHLjl7_Pz3KtKTQ_xal0KqwRnkG6LBk8Q&callback=initMap';
    document.body.appendChild(script);
})();
